import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { createUploadLink } from 'apollo-upload-client';

import { errorLink } from './error-link';

export function createClient(config: {
  uri?: string;
  connectToDevTools?: boolean;
}) {
  const { uri, connectToDevTools } = config;

  const authLink = setContext((_, { headers }) => {
    return {
      headers: {
        ...headers,
        'X-Requested-With': 'XMLHttpRequest',
      },
    };
  });

  const httpLink = createUploadLink({
    credentials:
      process.env.NEXT_PUBLIC_FEATURE_REVERSE_PROXY_API === 'true'
        ? 'same-origin'
        : 'include',
    fetch: (input: RequestInfo | URL, init?: RequestInit) => {
      const body: { operationName?: string } =
        typeof init?.body === 'string' ? JSON.parse(init.body) : {};
      return body.operationName
        ? fetch(`${input}?opname=${body.operationName}`, init)
        : fetch(input, init);
    },
    uri,
  });

  return new ApolloClient({
    cache: new InMemoryCache({
      typePolicies: {
        AnalysisResultSkillScore: {
          keyFields: ['skillId'],
        },
        UserShareInfo: {
          keyFields: ['shareHash'],
        },
      },
    }),
    connectToDevTools,
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
      },
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
      },
      mutate: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
      },
    },
    link: ApolloLink.from([authLink, errorLink, httpLink]),
  });
}

export const graphqlClient = createClient({
  uri:
    process.env.NEXT_PUBLIC_FEATURE_REVERSE_PROXY_API === 'true'
      ? `${process.env.NEXT_PUBLIC_FINDY_CODE_URL_BASE}/api/graphql`
      : `${process.env.NEXT_PUBLIC_EXCALIBUR_API_URL_BASE}/graphql/user`,
  connectToDevTools: process.env.NODE_ENV !== 'production',
});
